// extracted by mini-css-extract-plugin
module.exports = {"folderbuttonWrapper":"CreateFolderButton_folderbuttonWrapper__1TMKe","folderbutton":"CreateFolderButton_folderbutton__1cjST"};